function headers(config) {
    const { language = 'en_EN', token = null } = config;

    const requestHeaders = {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-localization': language,
    };

    if (token !== null) {
        requestHeaders.Authorization = `Bearer ${token}`;
    }

    return requestHeaders;
}

export default headers;
